// src/shared/components/LanguageSwitcher/index.jsx
import React from "react";
import { useTranslation } from "react-i18next";

const LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "ru", label: "Русский", short: "RU" },
];

export default function LanguageSwitcher({ className = "" }) {
  const { t, i18n } = useTranslation();

  const current = (i18n.language || "en").split("-")[0];
  const currentLang = LANGS.find((l) => l.code === current) || LANGS[0];

  const applyLanguage = (lng) => {
    if (lng === current) return;

    i18n.changeLanguage(lng);

    // сохраняем выбор
    try {
      localStorage.setItem("app-lang", lng);
    } catch (e) {}

    try {
      const oneYear = 60 * 60 * 24 * 365;
      document.cookie = `app-lang=${lng}; path=/; max-age=${oneYear}; SameSite=Lax`;
    } catch (e) {}
  };

  const handleSelect = (lng) => {
    applyLanguage(lng);
  };

  return (
    <div className={`dropdown ${className}`.trim()}>
      {/* Кнопка-пилюля с иконкой */}
      <button
        type="button"
        className="btn btn-sm btn-light d-flex align-items-center gap-2 rounded-pill px-3 shadow-sm"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span role="img" aria-label={t("language")}>
          🌐
        </span>
        <span className="fw-semibold">{currentLang.short}</span>
      </button>

      {/* Меню выбора языка */}
      <ul className="dropdown-menu dropdown-menu-end shadow-sm">
        {LANGS.map((lng) => (
          <li key={lng.code}>
            <button
              type="button"
              className={
                "dropdown-item d-flex justify-content-between align-items-center" +
                (lng.code === current ? " active" : "")
              }
              onClick={() => handleSelect(lng.code)}
            >
              <span>{lng.label}</span>
              {lng.code === current && (
                <span className="ms-2">✓</span>
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
